import React, { useCallback } from 'react';
import DownloadIcon from '../../../../../../resources/icons/download.svg';
import { useEventLeads } from '../../../../../../data/hooks/leads/useEventLeads';
import IconButton from '../../../../../elements/IconButton';
import { useEvent } from '../../../../../../data/hooks/eventHooks';

function DownloadButton(props) {
    const { className = '', eventId } = props,
        leads = useEventLeads(eventId),
        event = useEvent(eventId);

    const handleDownload = useCallback(() => {
        app.api.leads.downloadFile(eventId, event.name);
    }, [eventId]);

    if (!leads.length) return null;

    return (
        <IconButton className={className} onClick={handleDownload} secondary>
            <DownloadIcon />
        </IconButton>
    );
}

export default DownloadButton;
